// Core
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import {
  Box,
  Image,
  Flex,
  useColorModeValue,
} from '@chakra-ui/react';

// Assets
import NavbarLinks from './Links';
import logo from 'assets/img/logo.png';
import { ReactComponent as HamburgerIcon } from 'assets/svg/hamburger.svg';
import { ReactComponent as HamburgerOpenIcon } from 'assets/svg/hamburger-open.svg';

// Components
import NavbarResponsive from './Responsive';

export default function Navbar(props) {
  let navbarBg = useColorModeValue('rgba(224, 234, 255, 0.50)', 'rgba(5, 10, 25, 0.50)');
  let secondaryMargin = '0px';
  let paddingX = '15px';
  let navbarPosition = 'fixed';
  const mainPanel = React.useRef();
  let hamburgerColor = useColorModeValue('#0E1633', 'white');
  const btnRef = React.useRef();

  const [isOpenMenu, setIsOpenMenu ] = useState(false);

  return (
    <>
      <Flex
        position={navbarPosition}
        bg={navbarBg}
        backdropFilter='blur(4px)'
        borderBottom='1px solid rgba(56, 169, 225, 0.00)'
        transitionDelay="0s, 0s, 0s, 0s"
        transition-property="box-shadow, background-color, filter, border"
        transitionTimingFunction="linear, linear, linear, linear"
        alignItems={{ xl: 'center' }}
        display="flex"
        justifyContent={{ md: 'center' }}
        mt={secondaryMargin}
        px={{
          base: paddingX,
          lg: '32px',
        }}
        pb="16px"
        pt="32px"
        top="0px"
        w={{ base: '100%' }}
        zIndex="999"
      >
        <Flex
          maxW="1128px"
          w="100%"
          flexDirection={{
            base: 'row',
            md: 'row',
          }}
          alignItems={{ md: 'center' }}
        >
          <Flex
            display={{ sm: 'flex', lg: 'none' }}
            ref={mainPanel}
            alignItems="center"
            mr={{base: '15px', lg: 'unset'}}
            cursor="pointer"
          >
            { isOpenMenu ? (
              <HamburgerOpenIcon color={hamburgerColor} w="40px" h="40px" ref={btnRef} onClick={() => setIsOpenMenu(false)} />
            ) : (
              <HamburgerIcon color={hamburgerColor} w="40px" h="40px" ref={btnRef} onClick={() => setIsOpenMenu(true)} />
            )}
          </Flex>
          <Box mt={{ base: '5px', sm: '8px', md: '0px', lg: '0px' }}>
            <NavLink to="/">
              <Image
                src={logo}
                alt='lmctplus logo'
                maxWidth={{ base: '158px' }}
                pr={{sm: '10px', md: 'unset'}}
              />
            </NavLink>
          </Box>
          <Flex w="100%"
            pl={{sm: '0px', md: '44px'}}
            flexDirection={{
              sm: 'column', 
              md: 'row',   
            }}
            alignItems="center"
            position="relative"
            justifyContent="space-between">
            <NavbarLinks
              routes={props.routes}
              onOpen={props.onOpen}
              logoText={props.logoText}
              secondary={props.secondary}
              fixed={props.fixed}
              userData={props.userData}
              logoutModal={props.logoutModal}
              hasOverdue={props.hasOverdue}
              goToOverduePayment={props.goToOverduePayment}
              isOverduePaymentLoading={props.isOverduePaymentLoading}
            />
          </Flex>
        </Flex>
      </Flex>

      <NavbarResponsive
        routes={props.routes}
        onOpen={props.onOpen}
        logoText={props.logoText}
        secondary={props.secondary}
        fixed={props.fixed}
        setIsOpenMenu={setIsOpenMenu}
        isOpenMenu={isOpenMenu}
        userData={props.userData}
      />

    </>
  );
}

Navbar.propTypes = {
  brandText: PropTypes.string,
  variant: PropTypes.string,
  secondary: PropTypes.bool,
  fixed: PropTypes.bool,
  onOpen: PropTypes.func,
};
